import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'Do I have to give up coffee?',
  a: 'No, you just have to change how you drink it. We teach you how to "buffer" your caffeine so it burns fat instead of storing it.'
}, {
  q: 'Is this just another keto diet?',
  a: 'Absolutely not. We actually use strategic "Hormone-Safe" carbs to protect your thyroid and help you sleep.'
}, {
  q: 'How soon will I see results?',
  a: 'Most women see a visible difference in bloating and energy levels within the first 3 to 4 days.'
}, {
  q: 'Is there a lot of cooking involved?',
  a: 'No. The meals are simple, 15-minute "assembly" style plates using basic grocery store ingredients.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-wellness-cream" data-id="element-12">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-4xl md:text-5xl mb-6" data-id="element-15">
            Frequently Asked{' '}
            <span className="italic text-wellness-gold-dark" data-id="element-16">Questions</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="border border-wellness-sage/30 rounded-2xl overflow-hidden bg-white" data-id="element-18">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-19">
                <span className="font-serif text-xl md:text-2xl text-wellness-forest pr-8" data-id="element-20">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-wellness-sage shrink-0" data-id="element-21">
                  <ChevronDown data-id="element-22" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-23">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-24">
                    <div className="px-6 pb-6 font-sans font-light text-wellness-forest/80 leading-relaxed" data-id="element-25">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};